import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const options = {
  chart: {
    type: "pie",
    height: 600,
  },
  title: {
    text: "Diagram Tutupan Lahan di Kawasan Kawasan Air Terjun Bedegung Tahun 2014",
    style: { fontSize: "16px", fontWeight: "bold" },
  },
  subtitle: {
    text: "Sumber: Survey Lapang",
    style: { fontSize: "12px", color: "#666" },
  },
  tooltip: {
    pointFormat: "<b>{point.name}</b>: {point.y} Ha",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: {
        enabled: true,
        format: "{point.name} : {point.y} Ha",
        connectorColor: "#888",
        style: {
          fontSize: "12px",
          textOutline: "none",
        },
      },
      showInLegend: false,
    },
  },
  colors: [
    "#87b94e", // Hutan Sekunder
    "#63b4f4", // Kebun/Ladang
    "#f7b543", // Semak
    "#b77ac6", // Sungai
    "#57c0ad", // Padang Rumput
    "#a4d285", // Vegetasi
    "#6cc7b4", // Kolam Ikan
    "#c0e1a2", // Lahan Terbuka
    "#b0a6e3", // Pematang Kolam
    "#f4aab9", // Sawah
    "#99d3f8", // Tempat Parkir
    "#c7c7c7", // Jalan
    "#c48f65", // Bangunan
    "#e9c46a", // Bungalow/Vila
    "#f08080", // Tribun
  ],
  series: [
    {
      name: "Luas",
      colorByPoint: true,
      data: [
        { name: "Hutan Sekunder", y: 46.8 },
        { name: "Kebun/Ladang", y: 8.6 },
        { name: "Semak", y: 6.7 },
        { name: "Sungai", y: 3.5 },
        { name: "Padang Rumput", y: 2.7 },
        { name: "Vegetasi", y: 2.0 },
        { name: "Kolam Ikan", y: 1.4 },
        { name: "Lahan terbuka", y: 1.0 },
        { name: "Pematang Kolam", y: 0.34 },
        { name: "Sawah", y: 0.44 },
        { name: "Tempat Parkir", y: 0.3 },
        { name: "Jalan", y: 0.59 },
        { name: "Bangunan", y: 0.15 },
        { name: "Bungalow/Vila", y: 0.05 },
        { name: "Tribun", y: 0.01 },
      ],
    },
  ],
};

export default function DiagramBedegungHighchart() {
  return (
    <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
